import { useRelevantQueryParams } from '@frontend/common';
import { ReportClient } from '@frontend/report/api';
import { Report, ReportType } from '@frontend/report/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { getPudoColliStatesForTab } from '../pudo-colli-tab-states';

const normalizeExportData = (data: Record<string, any>): Record<string, any> =>
    Object.fromEntries(Object.entries(data).map(([key, value]) => [key, key !== 'state' && Array.isArray(value) && value.length === 1 ? value[0] : value]));

const useCollis = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { currentAccount } = useAccountRepository();
    const [activeTab, setActiveTab] = useState<string>('active');
    const [report, setReport] = useState<Report | null>(null);
    const reportModalId = 'pudo-collis-report-modal';
    const listId = `${activeTab}-collis-list`;
    const listState = useAppSelector((state) => state.lists[listId]);

    const stateFilter = getPudoColliStatesForTab(activeTab);

    const queryData: Record<string, any> = { ...useRelevantQueryParams(['tab']) };

    const exportData = useMemo<Record<string, any>>(
        () =>
            normalizeExportData({
                ...queryData,
                ...listState?.filter,
                ...listState?.activeFilters,
                ...(stateFilter && { state: stateFilter })
            }),
        [queryData, listState?.filter, listState?.activeFilters, stateFilter]
    );

    useEffect(() => {
        ReportClient.fetchReports({ type: ReportType.PUDO_COLLIS, account_id: currentAccount }).then((response) => {
            setReport(response.results[0] ?? null);
        });
    }, [currentAccount]);

    return {
        dispatch,
        navigate,
        location,
        currentAccount,
        activeTab,
        setActiveTab,
        stateFilter,
        listId,
        report,
        reportModalId,
        exportData
    };
};

export default useCollis;
